import { render, staticRenderFns } from "./TournamentMatchScheduler.vue?vue&type=template&id=10657813&scoped=true&"
import script from "./TournamentMatchScheduler.vue?vue&type=script&lang=js&"
export * from "./TournamentMatchScheduler.vue?vue&type=script&lang=js&"
import style0 from "./TournamentMatchScheduler.vue?vue&type=style&index=0&id=10657813&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10657813",
  null
  
)

component.options.__file = "TournamentMatchScheduler.vue"
export default component.exports